<template>
  <div class="card-form pt-1">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="getData"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageTable from './table.vue'
const initPage = { curPage: 1, pageSize: 20, pageTotal: 0 }
export default {
  components: { PageTable },
  props: { scmCode: { type: String, default: '' } },
  data() {
    return { loading: false, tableData: [], page: { ...initPage } }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      if (!this.scmCode) return

      this.$api
        .scmInfoContactsListApi({ ...this.page, scmCode: this.scmCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.page.pageTotal = res.body.count
          this.page.pageSize = res.body.pageSize
          this.page.curPage = res.body.curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
  },
}
</script>